module.exports = __webpack_public_path__ + "static/media/equipe-eden-avatar@2x.e2de0a81.png";


//////////////////
// WEBPACK FOOTER
// ./src/sass/images/equipe/equipe-eden-avatar@2x.png
// module id = 190
// module chunks = 0